import React from 'react'
import { TermsOfUseTpl } from '../../../components/templates'
import { Meta } from '../../../Meta'

export const TermsOfUse: React.FC = () => {
  return (
    <>
      <Meta title="利用規約" />
      <TermsOfUseTpl />
    </>
  )
}
